export var IconName;
(function (IconName) {
    IconName["LOCATION"] = "location";
    IconName["BAN"] = "ban";
    IconName["BRIEFCASE"] = "briefcase";
    IconName["BUSINESS"] = "business";
    IconName["CALENDAR"] = "calendar";
    IconName["MULTIPLY"] = "multiply";
    IconName["REMOVE"] = "remove";
    IconName["USERS"] = "users";
    IconName["CHECK"] = "check";
    IconName["SPINNER"] = "spinner";
    IconName["ADD"] = "add";
    IconName["BILLS"] = "bills";
    IconName["VERIFIED_FILL"] = "verified-fill";
    IconName["SITEMAP"] = "sitemap";
    IconName["SLIDERS"] = "sliders";
    IconName["SHIELD"] = "shield";
    IconName["CARET_DOWN"] = "caret-down-fill";
    IconName["CIRCLE_QUESTION"] = "circle-question";
    IconName["CHEVRON_DOWN"] = "chevron-down";
})(IconName || (IconName = {}));
export var IconColor;
(function (IconColor) {
    IconColor["PRIMARY"] = "primary";
    IconColor["DANGER"] = "danger";
})(IconColor || (IconColor = {}));
